import { useEffect } from 'react';
import { Typography, Dialog, DialogTitle, DialogActions, DialogContent, Button, Divider, Alert, Box, Link } from "@mui/material";
import { closelightbox } from "../../../util/Functions";
import { ModalStyle } from "../../../util/Styles";
import { usePreloadWorkers } from "./hooks/usePreloadWorkers";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import alboCard from '../../../images/alboCard.png'
import SnackbarContent from '@mui/material/SnackbarContent';

const AfbPreloadWorkers = ({ open, changeAlert, changeLoader, content }) => {
    const { data, form, error, isValidForm, zPos, dropZoneRef, onSelectFile, onConfirm, handleOver, handleLeave, handleDrop, saveData, onFormReset, onDownloadFile } = usePreloadWorkers(open, changeAlert, changeLoader);

    const action = (
        <Button size="small" variant="text" id='buttonText' onClick={onFormReset}>Cambiar</Button>
    );

    const addFile = () => {
        document.getElementById("file").click();
    };

    useEffect(() => {
        saveData(content);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);

    return (
        <Dialog open={true} fullWidth sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }}>
            <ModalStyle property={String(isValidForm)}>
                <DialogTitle>
                    <span>Preactivar Workers</span>
                </DialogTitle>

                <DialogContent>
                    { !form && 
                        <>
                        <Alert severity={"info"}>
                            Descarga el formato y llénalo con los datos de los colaboradores. No modifiques el formato del archivo.
                        </Alert>

                        <Box mt={2}>
                            <Link underline="none" color={null} display={"flex"} sx={{cursor: "pointer"}} width={"fit_content"} onClick={onDownloadFile.bind(this)}>
                                <ArrowCircleDownIcon sx={{verticalAlign: "middle", mr: 1}}/>
                                <Typography color={"inherit"}>Descargar formato.</Typography>
                            </Link>
                        </Box>
                        </>
                    }

					<Divider sx={{mt: 2}} />
                    { form && form["file_name"] ?
                        <Box sx={{mb: 1, textAlign: "center"}} display={"flex"}>
                            <Box component="img" alignSelf={"center"} alt="emptyList" src={alboCard} width={232}/>
                            <Box py={3} pl={2} alignContent={"center"}>
                                <SnackbarContent message={form["file_name"]} action={action} sx={{backgroundColor: "cadetblue", mb: 3, fontWeight: 800}} />
                                <Typography variant="body2">Estás a punto de <b>preactivar {form["total_count"]} cuentas</b></Typography>
                                <Typography variant="body2">para la empresa {data["corporate_name"]}</Typography>
                                <Typography variant="body2">¿Deseas continuar?</Typography>
                            </Box>
                        </Box> 
                        :
                        <>
                        <Box 
                            ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                            sx={{p: 3, mb: 1, mt: 3, border: "4px dashed lightgray", textAlign: "center", cursor: "pointer"}}>
                            <Typography sx={{fontWeight: "bold"}}>¿Ya llenaste y guardaste el formato?</Typography>
                            <CloudUploadIcon fontSize="large" color="action" sx={{m: 1}}/>
                            <Typography variant="body2">
                                Arrastra y suelta tu archivo o <Link >cárgalo desde tus documentos</Link>
                            </Typography>
                            <input id="file" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                        </Box>
                        <Typography variant="body2">Formatos válidos: .csv .xls y .xlsx.</Typography>
                        </>
                    }

                    {error && <Typography variant="body2" color="orangered">{error}</Typography>}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closelightbox} variant="outlined" id='buttonCancel'>
                        Cancelar
                    </Button>
                    <Button onClick={onConfirm.bind(this)} disabled={isValidForm} variant="contained">
                        Continuar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default AfbPreloadWorkers;
